import { FormControl, FormLabel } from "@mui/material";
import SwitchConfig from "../switch";

export default function SwitchStatus({...props}) {
    return (
        <FormControl component="fieldset" variant="standard">
            <FormLabel component="legend">Status</FormLabel>
            <SwitchConfig {...props}>
            </SwitchConfig>
        </FormControl>
    )
}